import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';

export namespace PermissionsLockDialogStyles {
  const permissionsLockDialogCssPrefix = 'PermissionsLockDialog';

  export const StatusIcon = cssClass(permissionsLockDialogCssPrefix, 'lock-status-icon', {
    marginRight: '8px',
    verticalAlign: 'middle',
  });

  export const RadioButtonLabel = cssClass(permissionsLockDialogCssPrefix, 'radio-button-label', {
    color: `${CommonStyles.Colors.Grey51}`,
    fontWeight: 'bold',
    height: `${CommonStyles.Sizes.NormalIconSize}px`,
    lineHeight: `${CommonStyles.Sizes.NormalIconSize}px`,
  });

  export const RadioButtonLabelContainer = cssClass(permissionsLockDialogCssPrefix, 'radio-button-label-container', {
    marginLeft: '2px',
    marginBottom: `${CommonStyles.Sizes.LargeSpace}px`,
  });

  export const PermissionOptionDescription = cssClass(permissionsLockDialogCssPrefix, 'permission-option-description', {
    marginLeft: `${CommonStyles.Sizes.DefaultSpace}px`,
    marginRight: `${CommonStyles.Sizes.LargeSpace}px`,
  });

  export const NestedProjectsOption = cssClass(permissionsLockDialogCssPrefix, 'nested-projects-option', {
    marginTop: `${CommonStyles.Sizes.MediumSpace}px`,
    $nest: {
      '& label div:first-child': {
        marginLeft: '0px !important', // remove margin before the checkbox
      },
    },
  });

  export const WarningIconContainer = cssClass(permissionsLockDialogCssPrefix, 'warning-icon', {
    display: 'inline-block',
    height: '13px',
    marginRight: '8px',
    minWidth: '13px',
  });

  export const WarningMessageContainer = cssClass(permissionsLockDialogCssPrefix, 'warning-message-container', {
    alignItems: 'start',
    backgroundColor: '#EEF5F9',
    borderLeft: `4px solid ${CommonStyles.Colors.HyperlinkBlueHover}`,
    display: 'flex',
    marginTop: `${CommonStyles.Sizes.MediumSpace}px`,
    padding: '8px',
  });
}
